import { Spinner } from '@ibsys/kit';
import { ArrowRightIcon, ChevronsDownIcon, FolderPlusIcon, PlusIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHasPermission } from '@/entities/profile';
import { IconButton } from '@/shared/ui';

type KmReportNodeActionsProps = {
  /** Идёт создание элемента структуры — вместо действий показывается ожидание */
  isCreating: boolean;
  onOpenCard: () => void;
  onExpandAll: (event: React.MouseEvent) => void;
  onAddGroup: () => void;
  onAddAssessment: () => void;
  isDesktop?: boolean;
};

/**
 * Действия строки заключения на модели знаний: переход к карточке, разворачивание структуры
 * целиком, добавление группы и единицы оценивания в корень заключения.
 */
export const KmReportNodeActions: FC<KmReportNodeActionsProps> = ({
  isCreating,
  onOpenCard,
  onExpandAll,
  onAddGroup,
  onAddAssessment,
  isDesktop,
}) => {
  const { t } = useTranslation('expertReport');
  const allowAdmin = useHasPermission('ADMIN_EXPERT_REPORT');

  if (isCreating) return <Spinner className="ml-auto size-4 shrink-0" />;

  const stopAnd = (action: () => void) => (event: React.MouseEvent) => {
    event.stopPropagation();
    action();
  };

  return (
    <div className="flex shrink-0 items-center gap-0.5">
      {!isDesktop && (
        <IconButton
          label={t('openCard')}
          size="icon"
          className="size-6"
          icon={<ArrowRightIcon className="size-3.5" />}
          onClick={stopAnd(onOpenCard)}
        />
      )}

      {isDesktop && (
        <div className="flex gap-0.5 opacity-0 transition-opacity group-hover/km-report:opacity-100">
          <IconButton
            label={t('expandAll')}
            size="icon"
            className="size-6"
            icon={<ChevronsDownIcon className="size-3.5" />}
            onClick={onExpandAll}
          />
          {allowAdmin && (
            <>
              <IconButton
                label={t('km.addGroup')}
                size="icon"
                className="size-6"
                icon={<FolderPlusIcon className="size-3.5" />}
                onClick={stopAnd(onAddGroup)}
              />
              <IconButton
                label={t('km.addAssessment')}
                size="icon"
                className="size-6"
                icon={<PlusIcon className="size-3.5" />}
                onClick={stopAnd(onAddAssessment)}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
};
